var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBidsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1469_7264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0614 82.1227C63.7389 82.1227 82.1227 63.7389 82.1227 41.0614C82.1227 18.3838 63.7389 0 41.0614 0C18.3838 0 0 18.3838 0 41.0614C0 63.7389 18.3838 82.1227 41.0614 82.1227Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.667 135.005H201.867L133.887 202.985V209.784L208.667 135.005Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.177 135.005H178.375L133.887 179.492V186.295L185.177 135.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.922 135.005H190.123L133.887 191.24V198.04L196.922 135.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.411 135.005H213.612L133.887 214.73V221.529L220.411 135.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.156 135.005H225.357L133.887 226.474V233.274L232.156 135.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.881 135.005H143.194L133.887 144.312V150.998L149.881 135.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.9 135.005H237.101L133.887 238.219V245.018L243.9 135.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.426 135.005H166.6L133.887 167.718V174.544L173.426 135.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 135.005H260.594L133.887 261.708V265.118H137.277L264 138.395V135.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 260.789L259.675 265.117H264V260.789Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.887 139.366L138.249 135.005H133.887V139.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.655 135.005H154.826L133.887 155.944V162.769L161.655 135.005Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 208.866V202.066L200.948 265.118H207.748L264 208.866Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 220.61V213.811L212.693 265.117H219.492L264 220.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5 232.147L231.03 264.618H225.645L263.5 226.763V232.147Z",
    fill: "#F4F3F3",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5 255.637L254.519 264.618H249.134L263.5 250.252V255.637Z",
    fill: "#F4F3F3",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5 243.892L242.774 264.617H237.389L263.5 238.507V243.892Z",
    fill: "#F4F3F3",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5 161.677L160.562 264.618H155.177L263.5 156.295V161.677Z",
    fill: "#F4F3F3",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5 149.932L148.814 264.617H143.433L263.5 144.55V149.932Z",
    fill: "#F4F3F3",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.438 135.505L134.387 255.556V250.171L249.056 135.505H254.438Z",
    fill: "#F4F3F3",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5 185.169L184.051 264.618H178.667L263.5 179.784V185.169Z",
    fill: "#F4F3F3",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5 173.421L172.307 264.617H166.922L263.5 168.039V173.421Z",
    fill: "#F4F3F3",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5 196.913L195.796 264.617H190.411L263.5 191.528V196.913Z",
    fill: "#F4F3F3",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.115 82.1191H91.2341V90.6233H119.221C120.826 87.5387 122.813 84.683 125.121 82.1225H125.115V82.1191Z",
    fill: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.007 74.1152C130.622 76.1739 127.559 78.7077 124.906 81.6191H91.7375V74.1152H134.007Z",
    fill: "#F4F3F3",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.275 65.6074V68.127H155.407C148.283 68.127 141.582 69.9335 135.733 73.1113H91.731V65.6074H159.275Z",
    fill: "white",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3123 48.6025H156.7C158.122 48.6025 159.278 49.7557 159.278 51.1807V56.1064H91.7341V51.1807C91.7341 49.7583 92.8873 48.6025 94.3123 48.6025Z",
    fill: "white",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.278 57.1064V64.6104H91.7341V57.1064H159.278Z",
    fill: "white",
    stroke: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2343 99.127V104.55C91.2343 106.251 92.614 107.628 94.3122 107.628H114.687C114.81 104.706 115.248 101.867 115.954 99.1402L115.868 99.127H91.231H91.2343Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.218 90.623H91.2375V99.1272H115.874L115.961 99.1405C116.733 96.1554 117.835 93.2997 119.228 90.623H119.221H119.218Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.208 116.132C114.843 113.936 114.651 111.684 114.651 109.386C114.651 108.795 114.667 108.212 114.69 107.628H79.1978C77.4963 107.628 76.1199 109.008 76.1199 110.706V116.129H115.208V116.132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.602 124.637C116.511 121.934 115.699 119.088 115.208 116.133H76.1199V124.637H117.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.286 133.141C120.405 130.521 118.826 127.668 117.602 124.637H76.1199V133.141H122.289H122.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.491 141.645H76.1199V147.071C76.1199 148.772 77.4996 150.149 79.1978 150.149H155.41C146.024 150.149 137.38 146.975 130.491 141.645Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.491 141.645C127.364 139.224 124.597 136.358 122.286 133.141H76.1165V141.645H130.488H130.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.015 109.389C119.015 86.8786 137.264 68.6299 159.775 68.6299H155.407C132.896 68.6299 114.647 86.8786 114.647 109.389C114.647 131.9 132.896 150.149 155.407 150.149H159.775C137.264 150.149 119.015 131.9 119.015 109.389Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.778 150.149C182.289 150.149 200.538 131.9 200.538 109.389C200.538 86.8785 182.289 68.6299 159.778 68.6299C137.267 68.6299 119.019 86.8785 119.019 109.389C119.019 131.9 137.267 150.149 159.778 150.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.311 182.959L119.625 184.937L137.048 192.535L183.23 171.928C185.95 170.657 189.184 171.364 191.127 173.652C193.476 176.425 193.167 180.568 190.438 182.959L143.632 223.987C140.185 227.009 135.373 227.928 131.054 226.389L78.0613 207.509C74.7479 206.328 71.0563 207.031 68.4062 209.343L29.5625 187.808L82.1131 164.919C86.332 163.042 91.0219 162.481 95.5658 163.307L146.858 172.77C149.495 173.251 151.319 175.675 151.054 178.342C150.805 180.83 148.805 182.777 146.311 182.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.45 185.489L146.439 183.095C148.933 182.912 150.933 180.965 151.181 178.478C151.447 175.811 149.623 173.387 146.986 172.906L95.0057 163.443C90.4618 162.617 85.7719 163.178 81.553 165.055L29.0024 187.944C25.9344 189.28 22.5049 187.032 22.5049 183.685V36.1394C22.5049 30.8956 26.757 26.6436 32.0007 26.6436H229.218C234.462 26.6436 238.714 30.8956 238.714 36.1394V100.726C238.714 106.027 234.419 110.325 229.118 110.325L209.029 110.332C204.465 110.332 200.588 113.559 199.626 118.02C195.666 136.385 179.331 150.149 159.782 150.149C137.245 150.149 118.873 131.649 119.022 109.111C119.172 86.7265 137.364 68.627 159.782 68.627C173.168 68.627 185.049 75.0814 192.478 85.0449",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.536 185.049L136.963 192.76L183.145 172.153C185.865 170.883 189.099 171.589 191.042 173.878C193.39 176.65 193.082 180.793 190.352 183.184L143.546 224.213C140.1 227.234 135.288 228.153 130.969 226.614L77.9046 207.705C74.5912 206.524 70.8996 207.228 68.2495 209.539L39.5397 234.714C36.3159 237.539 38.3159 242.85 42.6011 242.85H229.218C234.462 242.85 238.714 238.597 238.714 233.354V137.118",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.779 68.627H155.41C132.9 68.627 114.651 86.8757 114.651 109.386C114.651 131.897 132.9 150.146 155.41 150.146H159.779",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.17 88.627L160.157 82.71",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.269 136.066L160.256 130.152",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.86 100.799L168.843 92.9918C168.794 90.3915 167.175 88.627 164.84 88.627H155.593C151.971 88.627 150.621 90.0863 150.697 94.1195L150.767 100.415C150.8 102.073 151.473 103.436 152.634 104.179L166.896 113.333C168.054 114.076 168.731 115.44 168.764 117.098L168.857 124.206C168.933 128.239 168.2 130.153 164.578 130.153H154.727C152.392 130.153 150.774 128.385 150.724 125.788L150.697 118.66",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.41 150.149H79.1981C77.4966 150.149 76.1201 148.769 76.1201 147.071V110.71C76.1201 109.008 77.4999 107.632 79.1981 107.632H114.647",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1169 141.646H130.492",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1169 133.141H122.283",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2346 99.1279H115.871",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2346 90.624H119.218",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2346 82.1191H125.115",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2346 73.6152H135.858",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2346 65.1113H159.779",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2346 56.6074H159.779",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1169 124.637H117.6",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1169 116.133H115.205",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.035 107.628H94.3157C92.6142 107.628 91.2378 106.248 91.2378 104.55V51.1805C91.2378 49.479 92.6176 48.1025 94.3157 48.1025H156.7C158.402 48.1025 159.778 49.4823 159.778 51.1805V68.6266",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1469_7264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 264,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidsIcon);
export default __webpack_public_path__ + "static/media/bids-icon.b9675346.svg";
export { ForwardRef as ReactComponent };